module.exports = __webpack_public_path__ + "static/img/0007.fbe0504b.png";